








































































































import Vue from "vue";
import { Component } from "nuxt-property-decorator";
import {
  faEye,
  faPlus,
  faHome,
  faAngleLeft,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import amplitude from "amplitude-js";
import { encrypt, parseEmoji } from "~/shared";
import { Feed } from "~/types/feed";
import { Project } from "~/types/project";
import { paymentModuleActive } from "~/config";
import BaseLoader from "~/components/core/BaseLoader.vue";

@Component({
  name: "InspirationPage",
  components: {
    BaseLoader,
  },
})
export default class InspirationPage extends Vue {
  prevRoute: { path: string; query: any } = { path: "", query: {} };
  isFetching = false;

  get faEye() {
    return faEye;
  }

  get faHome() {
    return faHome;
  }

  get faLock() {
    return faLock;
  }

  get faPlus() {
    return faPlus;
  }

  get faAngleLeft() {
    return faAngleLeft;
  }

  get isAuth() {
    return this.$store.getters.isAuth as boolean;
  }

  get feed(): Feed[] {
    return this.$store.getters["feed/feed"];
  }

  get project(): Project | null {
    return this.$store.getters["projects/activeProject"];
  }

  get paymentModuleActive() {
    return paymentModuleActive;
  }

  get isPremium(): boolean {
    return this.$store.getters.isPremium;
  }

  get isUnlimited(): boolean {
    return this.$store.getters.isUnlimited;
  }

  get isPremiumV2(): boolean {
    return this.$store.getters.isPremiumV2;
  }

  get isLifelong(): boolean {
    return this.$store.getters.isLifelong;
  }

  get isFree(): boolean {
    return (
      !this.isPremium &&
      !this.isLifelong &&
      !this.isPremiumV2 &&
      !this.isUnlimited
    );
  }

  get projects(): Project[] {
    return this.$store.getters["projects/projects"];
  }

  getBadge(feed: Feed) {
    if (!feed.products || (feed.products && feed.products.length <= 10)) {
      return "FREE";
    }

    if (feed.products.length <= 30) {
      return "PREMIUM";
    }

    return "UNLIMITED";
  }

  showLock(feed: Feed) {
    if (!feed.products || (feed.products && feed.products.length <= 10)) {
      return false;
    }

    if (feed.products.length > 10 && this.isFree) {
      return true;
    }

    if (feed.products.length > 30 && this.isPremiumV2) {
      return true;
    }

    return false;
  }

  beforeRouteEnter(
    _to: string,
    from: { path: string; query: any },
    next: Function
  ) {
    next((vm: InspirationPage) => {
      vm.prevRoute = from;
    });
  }

  getPreviewUrl(projectId: number) {
    return (
      "/showcase/" +
      encrypt(projectId.toString(), process.env.PROJECT_ID_SALT as string)
    );
  }

  parseEmoji(text: string) {
    return parseEmoji(text, this);
  }

  onNavigateBack() {
    this.$router.push(this.prevRoute);
  }

  async onCreateProject(feed: Feed) {
    if (this.paymentModuleActive && this.isFree && this.projects.length >= 1) {
      return this.$showPaymentBlocker(
        this.$tc("popups.payment_blocker.too_many_projects.heading"),
        this.$tc("popups.payment_blocker.too_many_projects.btn")
      );
    }

    if (
      this.paymentModuleActive &&
      this.isPremiumV2 &&
      this.projects.length >= 3
    ) {
      return this.$showPaymentBlocker(
        this.$tc("popups.payment_blocker.too_many_projects_premium.heading"),
        this.$tc("popups.payment_blocker.too_many_projects_premium.btn")
      );
    }

    const errorMessage = await this.$store.dispatch(
      "projects/createProjectFromTemplate",
      feed
    );

    if (errorMessage) {
      this.$notify({ type: "error", message: errorMessage });
      return;
    }

    if (process.client) {
      amplitude.getInstance().logEvent("project_as_template", {
        projectId: feed.id,
      });
    }

    this.$notify({
      type: "success",
      message: this.$tc("pages.inspiration.success"),
    });

    if (this.project) {
      this.$router.push("/mein-vanausbau/" + this.project.id + "/dashboard");
    }
  }

  async fetch() {
    this.isFetching = true;
    if (this.isAuth) {
      await this.$store.dispatch("projects/fetchProjects");
    }
    this.isFetching = false;
  }
}
